/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgFunnelNavigateBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.5 17L22.5 17M22.5 17L18.9 13M22.5 17L18.9 21M11 19.4123L8.25 21V14.432C8.25 13.8352 8.01295 13.2629 7.59099 12.841L2.15901 7.40901C1.73705 6.98705 1.5 6.41476 1.5 5.81802V4.77404C1.5 4.23357 1.88408 3.76805 2.41694 3.67769C5.04479 3.23206 7.74533 3 10.5001 3C13.2548 3 15.9552 3.23205 18.5831 3.67767C19.1159 3.76803 19.5 4.23355 19.5 4.77402V5.81802C19.5 6.41476 19.2629 6.98705 18.841 7.40901L16.75 9.5"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SvgFunnelNavigate = wrapIcon(SvgFunnelNavigateBase);
export default SvgFunnelNavigate;
